import React from 'react';
import { Button } from './ui/button';
import './BookingSection.css';

const BookingSection = () => {
  return (
    <section className="booking-section">
      <div className="booking-container">
        <div className="booking-content">
          <h2 className="booking-title">BOOK</h2>
          <div className="divider"></div>
          <p className="booking-text">
            Appointments by booking. Arrive on time. Leave defined.
          </p>
          <Button 
            className="booking-button"
            onClick={() => window.open('https://www.fresha.com/book-now/the-lodge-inside-salon-rose-d5hpq959/all-offer?share=true&pId=1274239', '_blank')}
          >
            BOOK YOUR VISIT
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BookingSection;